import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useSubstantiveExaminationService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetSubstantiveExamination, setFetchingGetSubstantiveExamination] = useState(false);
    const [fetchingCreateSubstantiveExamination, setFetchingCreateSubstantiveExamination] = useState(false);
    const [fetchingGetOfficialPublicationId, setFetchingGetOfficialPublicationId] = useState(false);
    const [fetchingInapiAutofill, setFetchingInapiAutofill] = useState(false);

    const getOfficialPublicationId = (brandRegistrationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brandRegistrationId}/official-publication-id`),
            setFetching: setFetchingGetOfficialPublicationId
        });
    };

    const getSubstantiveExamination = (officialPublicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/substantive-examination/${officialPublicationId}`),
            setFetching: setFetchingGetSubstantiveExamination
        });
    };

    const createSubstantiveExamination = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('brand-registrations/substantive-examination/create'),
            body: data,
            setFetching: setFetchingCreateSubstantiveExamination
        });
    };

    const getInapiDataForAutofill = (officialPublicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/substantive-examination/${officialPublicationId}/inapi-autofill`),
            setFetching: setFetchingInapiAutofill
        });
    };

    return {
        getOfficialPublicationId,
        getSubstantiveExamination,
        createSubstantiveExamination,
        getInapiDataForAutofill,
        fetchingGetOfficialPublicationId,
        fetchingGetSubstantiveExamination,
        fetchingCreateSubstantiveExamination,
        fetchingInapiAutofill
    };
};

export default useSubstantiveExaminationService;

